import { render, staticRenderFns } from "./left_4.vue?vue&type=template&id=94712f10&scoped=true&"
import script from "./left_4.vue?vue&type=script&lang=js&"
export * from "./left_4.vue?vue&type=script&lang=js&"
import style0 from "./left_4.vue?vue&type=style&index=0&id=94712f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94712f10",
  null
  
)

export default component.exports